/* eslint-disable import/no-named-as-default */
import AnchorCenter from '~/pages/AnchorCenter/reducers'
import worldCup from '~/pages/worldCup/pages/reducers'
import AnchorTaskSystem from '~/pages/AnchorTaskSystem/reducers'
import ChatCenter from '~/pages/ChatCenter/reducers'
import CoinAgencyRecharge from '~/pages/Coinagency/AgencyRecharge/reducers'
import CoinAgencyWallet from '~/pages/Coinagency/AgencyWallet/reducers'
import WealthLevel from '~/pages/WealthLevel/pages/reducers'
import InviteFission from '~/pages/InviteFission/pages/reducers'
import DistributorManage from '~/pages/Coinagency/DistributorManage/reducers'
import VoteMachine from '~/pages/voteMachine/pages/reducers'
import DoubleRoomTask from '~/pages/DoubleRoomTask/reducer'
import NewUserJoinGuide from '~/pages/NewUserJoinGuide/pages/reducers'
import PersonalDressUp from '~/pages/PersonalDressUp/reducers'
// eslint-disable-next-line import/order
import FamilyPk from '~/pages/FamilyPk/reducers'
import OldUserRecall from '~/pages/OldUserRecall/pages/reducers'
import StarGift from '~/pages/StarGift/pages/reducers'
import NewCoinagency from '~/pages/Coinagency/pages/reducers'
import RaceHonorWall from '~/pages/RaceHonorWall/reducers'
import TreasureBox from '~/pages/TreasureBox/pages/reducers'
import FeedBack from '~/pages/Feedback/reducers'
import JoinGuide from '~/pages/JoinGuide/pages/reducers'
import CoinAgencyCollectSalary from '~/pages/CoinAgencyCollectSalary/pages/reducers'
import RedEnvelope from '~/pages/RedEnvelope/pages/reducers'
import Pk from '~/pages/Pk/pages/home/reducers'
import PartyGala from '~/pages/PartyGala/pages/reducers'
import RedemptionMall from '~/pages/RedemptionMall/pages/reducers'
import PKRules from '~/pages/Pk/pages/rule/reducers'
import BuyCoin from '~/pages/BuyCoin/reducers'
import GameBackRewards from '~/pages/game/components/BackRewards/reducers'
import GameEggMachine from '~/pages/game/EggMachine/reducers'
import GameGreedyHiya from '~/pages/game/GreedyHiya/reducers'
import GameGreedyPro from '~/pages/game/GreedyProGame/reducers'
import GameLuckySlot from '~/pages/game/LuckySlot/reducers'
import GameRoulette from '~/pages/game/roulette/reducers'
import fruitSlot from '~/pages/game/fruitSlot/reducers'
import GameGuessbox from '~/pages/game/guessbox/reducers'
import GameGreedyBox from '~/pages/game/GreedyBox/reducers'
import GameGuessGift from '~/pages/game/GuessGift/reducers'
import GameHitEgg from '~/pages/game/HitEgg/reducers'
import GameLuckyBigWheel from '~/pages/game/LuckyBigWheel/reducers'
import GameLuckyHiya from '~/pages/game/LuckyHiya/reducers'
import GameTeenPatti from '~/pages/game/TeenPatti/reducers'
import GameWorldCup from '~/pages/game/WorldCup/reducers'
import HorseGame from '~/pages/game/HorseGame/reducers'
import GuildSettled from '~/pages/GuildSettled/reducers'
import UserVerification from '~/pages/game/UserVerification/reducers'
// import GameTeenPatti from '~/pages/game/TeenPattiNext/reducers'
import Hunting from '~/pages/Hunting/reducers'
import BD from '~/pages/Hunting/BD/pages/reducers'
import NewBIgR from '~/pages/NewBIgR/reducers'
import NormalVipActive from '~/pages/NormalVipActive/reducers'
import NormalSend from '~/pages/Send/reducers'
import SongRoomTaskCenter from '~/pages/SongRoomTask/reducers'
import RoomDataBoard from '~/pages/RoomDataBoard/pages/reducers'
import SalaryFeedback from '~/pages/Union/Anchor/SalaryFeedback/reducers'
import WithdrawSalary from '~/pages/Union/Anchor/WithdrawSalary/reducers'
import UnionGatherInfo from '~/pages/Union/GatherInfo/reducers'
import TalentsGatherInfo from '~/pages/TalentsCenter/GatherInfo/reducers'
import UnionData from '~/pages/Union/Leader/Data/reducers'
import unionSettlement from '~/pages/Union/Leader/Settlement/reducers'
import SignUp from '~/pages/Union/Leader/SignUp/reducers'
import UnionLeaderWithdrawSalary from '~/pages/Union/Leader/WithdrawSalary/reducers'
import UnionMedal from '~/pages/Union/Medal/reducers'
import SalaryWallet from '~/pages/Union/SalaryWallet/reducers'
import UnionPK from '~/pages/UnionPK/reducers'
import UnionTask3 from '~/pages/UnionTask3/reducers'
import UserInfoCollection from '~/pages/UserInfoCollection/reducers'
import VChatCenter from '~/pages/VideoChatCenter/reducers'
import Virtual from '~/pages/virtual/reducers'
import Wallet2PayPal from '~/pages/wallet2/PayPal/reducers'
import Wallet2Payoneer from '~/pages/wallet2/payoneer/reducers'
import Wallet2Pandapay from '~/pages/wallet2/PandaPay/reducers'
import chatBDHunting from '~/pages/ChatBD/reducers'
import Wallet2Stripe from '~/pages/wallet2/stripe/reducers'
import Wallet2Checkout from '~/pages/wallet2/checkout/reducers'
import Wallet2CheckoutFlow from '~/pages/wallet2/checkoutFlow/reducers'
import Wallet2StripeNew from '~/pages/wallet2/stripeNew/reducers'
import Wallet2CheckoutNew from '~/pages/wallet2/checkoutNew/reducers'
import Wallet2RechargeExtra from '~/pages/wallet2/rechargeExtra/reducers'
import TalentsCenter from '~/pages/TalentsCenter/reducers'
import LuckyGift from '~/pages/LuckyGift/reducers'
import BlindBoxGift from '~/pages/BlindBoxGift/reducers'
import GuessCoins from '~/pages/game/components/GuessCoins/reducers'
import DistributorManageSuper from '~/pages/Coinagency/DistributorManageSuper/reducers'
import GreedyMold from '~/pages/game/GreedyMold/reducers'
import GreedyCat from '~/pages/game/GreedyCat/reducers'
import RankCenter from '~/pages/saada/rank-center/reducers'
import PowerNewUser from '~/pages/PowerNewUser/reducers'
import HelpCenter from '~/pages/HelpCenter/reducers'
import TalentApply from '../pages/TalentApply/reducers'
import CardMixture from '../pages/CardMixture/reducers'
import GiftBook from '../pages/GiftBook/reducers'
import FirstCharge from '../pages/FirstCharge/reducers'
import PaidUserUnderTakingGroup from '../pages/PaidUserUnderTakingGroup/reducers'
import ActivitySharing from '../pages/ActivitySharing/reducers'
import AnchorQuit from './AnchorQuit'
import AnchorQuitList from './AnchorQuitList'
import CrossRoomPkRank from './CrossRoomPkRank'
import GeneralLottery from './GeneralLottery'
import UnionTask from './UnionTask'
import newWallet from '../pages/NewWallet/reducers'
import Animal_Ocelot_OffSite from '../pages/OffSiteRecharge/reducers'
import PaymentBlock from '../pages/PaymentBlock/reducers'
import OffsiteShare from '../pages/OffsiteShare/pages/reducers'
import wallet from './wallet'
import MonthlyInfluence from './MonthlyInfluence'
import Vip from './vip'
import Medal from './medal'
import GiftWall from './GiftWall'
import DressUpBook from './DressUpBook'
import NewAnchorcenter from '../pages/NewAnchorcenter/reducers'
import Lord from './lord'
import Saada from './saada'
import ManPower from '~/pages/saada/manPower/reducers'
import UserBdVerify from '~/pages/UserBdVerify/reducers'
import IRHome from '~/pages/IntimateRelationship/pages/home/reducers'
import IRInvite from '~/pages/IntimateRelationship/pages/Invite/reducers'
import Wallet2Airwallex from '~/pages/wallet2/airwallex/reducers'
import GoldMiner from '~/pages/game/GoldMiner/reducers'
import GreedyRocket from '~/pages/game/GreedyRocket/reducers'
import ReplyTwo from '~/pages/saada/ReplyTwo/reducers'
import Fomo from '~/pages/game/components/Fomo/reducers'
import King from '~/pages/game/components/King/reducers'
import Ramadan from '~/pages/saada/Ramadan/reducers'
import SaadaWish from '~/pages/saada/Wish/reducers'
import SaadaWishActivity from '~/pages/saada/WishActivity/reducers'
import ShareOut from '~/pages/Share/reducers'
import ThridMidPage from '~/pages/game/ThridMidPage/reducers'
import SaadaPurse from '~/pages/saada/Purse/reducers'
import GameRoyalWild from '~/pages/game/RoyalWild/reducers'
import GreedySports from '~/pages/game/GreedySports/reducers'
import TaskCenter from '~/pages/TaskCenter/reducers'
import WeeklyCardGlobalModal from '~/pages/saada/WeeklyCardGlobalModal/reducers'
import GameCenter from '~/pages/game/GameCenter/reducers'
import JustGame from '~/pages/game/components/justgame/reducers'
import SVIPUpdate from '~/pages/SVIPUpdate/reducers'
import MonthlyInfluenceV2 from './MonthlyInfluenceV2'
import LuckGiftWordCup from '~/pages/LuckGiftWordCup/reducers'

export default {
  worldCup,
  Animal_Manatee: UserBdVerify,
  Animal_U: UserVerification,
  ...MonthlyInfluence,
  Animal_Panda: Wallet2Pandapay,
  ...Lord,
  ...Saada,
  ...GiftWall,
  ...DressUpBook,
  ...Medal,
  ...Vip,
  SongRoomTaskCenter,
  RoomDataBoard,
  NewAnchorcenter,
  Animal_Pangolin: Wallet2PayPal,
  Animal_Zebra: Wallet2Stripe,
  Animal_Narwhal: SalaryFeedback,
  Virtual,
  Animal_Swan: unionSettlement,
  Animal_Buffalo: UnionPK,
  OldUserRecall,
  Animal_Penguin: FamilyPk,
  Animal_Chipmunk: StarGift,
  Animal_Octopus: NewCoinagency,
  NewBIgR,
  Animal_Owl: GameGuessbox,
  Animal_Raccoon: GameGreedyBox,
  RankCenter,
  UnionTask,
  Animal_Phoenix: GeneralLottery,
  CrossRoomPkRank,
  AnchorQuit,
  AnchorQuitList,
  DoubleRoomTask,
  NewUserJoinGuide,
  PersonalDressUp,
  Animal_Cheetah: GameGreedyHiya,
  Animal_Shark: GameGreedyPro,
  Animal_Rabbit: GameLuckySlot,
  Animal_Vulture: GameRoulette,
  Animal_Sloth: fruitSlot,
  Hunting,
  BD,
  Animal_Ocelot_OffSite,
  Animal_Ocelot_pyBlock: PaymentBlock,
  OffsiteShare,
  Animal_Ocelot: newWallet,
  Animal_Panther: wallet,
  Animal_Hyena: WithdrawSalary,
  UnionData,
  SignUp,
  VoteMachine,
  NormalSend,
  Animal_Stork: GameLuckyHiya,
  UserInfoCollection,
  Animal_Seal: GameBackRewards,
  Animal_Otter: GameEggMachine,
  Animal_Heron: CoinAgencyWallet,
  Animal_Tapir: WealthLevel,
  InviteFission,
  Animal_Finch: CoinAgencyRecharge,
  Animal_Cobra: UnionLeaderWithdrawSalary,
  UnionTask3,
  UnionMedal,
  AnchorTaskSystem,
  Animal_Marten: NormalVipActive,
  Animal_Pelican: GameLuckyBigWheel,
  PartyGala,
  ChatCenter,
  Animal_Hare: GameGuessGift,
  RaceHonorWall,
  Animal_Tiger: TreasureBox,
  FeedBack,
  JoinGuide,
  Animal_Crane: CoinAgencyCollectSalary,
  Animal_Rat: RedEnvelope,
  Pk,
  RedemptionMall,
  PKRules,
  Animal_Canary: BuyCoin,
  UnionGatherInfo,
  Animal_Bobcat: DistributorManage,
  Animal_Raven: GameTeenPatti,
  Animal_Crab: GameHitEgg,
  Animal_Crow: GameWorldCup,
  Animal_Falcon: HorseGame,
  AnchorCenter,
  VChatCenter,
  GuildSettled,
  Animal_Bison: GiftBook,
  Animal_Wren: FirstCharge,
  Animal_Deer: PaidUserUnderTakingGroup,
  Animal_Porcupine: LuckyGift,
  Animal_Gopher: BlindBoxGift,
  Animal_Koala: SalaryWallet,
  CardMixture,
  Animal_Leopard: Wallet2Checkout,
  Animal_Leopard_new: Wallet2CheckoutNew,
  Animal_Zebra_new: Wallet2StripeNew,
  Animal_Leopard_flow: Wallet2CheckoutFlow,
  TalentApply,
  TalentsCenter,
  Animal_Ibex: DistributorManageSuper,
  Animal_Cougar: Wallet2Payoneer,
  TalentsGatherInfo,
  chatBDHunting,
  Animal_Jaguar: Wallet2RechargeExtra,
  Animal_Dove: GuessCoins,
  PowerNewUser,
  Animal_Weasel: GreedyMold,
  Animal_Mink: GreedyCat,
  HelpCenter,
  ActivitySharing,
  ManPower,
  IRHome,
  IRInvite,
  Animal_Goat: Wallet2Airwallex,
  Animal_Coyote: GoldMiner,
  Animal_Albatross: GreedyRocket,
  ReplyTwo,
  Fomo,
  King,
  Ramadan,
  SaadaWish,
  SaadaWishActivity,
  ShareOut,
  Animal_Badger: ThridMidPage,
  Animal_Puma: SaadaPurse,
  TaskCenter,
  WeeklyCardGlobalModal,
  Animal_Moose: JustGame,
  Animal_Flamingo: GameRoyalWild,
  Animal_Horse: GreedySports,
  Animal_Lynx: GameCenter,
  Animal_Hamster: SVIPUpdate,
  ...MonthlyInfluenceV2,
  LuckGiftWordCup,
}
